module.exports = __webpack_public_path__ + "20250721160708/img/wx_sh.4e175bb4.png";